<template>
  <div class="premium-sticky-cta">
    <div class="premium-sticky-cta__info">
      <v-icon small color="#FFD54F">mdi-crown</v-icon>
      <div>
        <strong>Desbloqueie comissões da rede</strong>
        <span v-if="potentialEarnings > 0" class="premium-sticky-cta__value">
          Potencial {{ formatCurrency(potentialEarnings) }}
        </span>
      </div>
    </div>
    <v-btn color="#e5183d" dark small depressed @click="$emit('cta')">
      Ser Premium
    </v-btn>
  </div>
</template>

<script lang="ts">
import { formatPremiumCurrency } from "@/config/premiumProgram";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PremiumStickyCta",
  props: {
    potentialEarnings: { type: Number, default: 0 },
  },
  emits: ["cta"],
  setup() {
    return { formatCurrency: formatPremiumCurrency };
  },
});
</script>

<style scoped lang="scss">
.premium-sticky-cta {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(90deg, #1a1a2e, #2d2d44);
  color: #fff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}
.premium-sticky-cta__info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.82rem;
  line-height: 1.3;
}
.premium-sticky-cta__info strong {
  display: block;
}
.premium-sticky-cta__value {
  display: block;
  color: #FFD54F;
  font-size: 0.75rem;
}
@media (min-width: 960px) {
  .premium-sticky-cta {
    display: none;
  }
}
</style>
